<template>
  <div :class="['Content-Detail', cp_show_border && 'show-border']">
    <articleContent
      v-for="(item, index) in list"
      :key="index"
      from="home"
      :art-content="item"
    />
  </div>
</template>

<script>
import articleContent from '../articleContent';
export default {
    name: 'ContentDetail',
    components: {
        articleContent,
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        cp_show_border () {
            if (this.list.length) {
                const item = this.list[0];
                return item.contentType === 0;
            }
            return false;
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../style.scss";
.Content-Detail {
    width: $pageWidth;
    background-color: #FFFFFF;
    margin: 0 auto;
    padding: 40px 0;
    &.show-border {
        border-bottom: 1px solid #e8eaec;
    }
}
</style>
